import type { JSONNode } from '@atlaskit/editor-json-transformer/types';
import { fg } from '@atlaskit/platform-feature-flags';

import type { AiSelectionContextPlugin } from './aiSelectionContextPluginType';
import {
	createContextExtractorRegistry,
	getAdditionalContextForFragments,
} from './editor-actions/actions';
import type { NodeContextFragmentExtractor } from './editor-actions/types';

export const aiSelectionContextPlugin: AiSelectionContextPlugin = () => {
	const contextExtractorRegistry = createContextExtractorRegistry();

	return {
		name: 'aiSelectionContext',
		actions: {
			registerContextExtractor: (nodeType: string, extractor: NodeContextFragmentExtractor) => {
				if (!fg('maui_remixable_page_native_embeds')) {
					return;
				}

				contextExtractorRegistry.register(nodeType, extractor);
			},
			getAdditionalContextForFragments: (fragments: JSONNode[]) => {
				if (!fg('maui_remixable_page_native_embeds')) {
					return {};
				}

				return getAdditionalContextForFragments(fragments, contextExtractorRegistry);
			},
		},
	};
};
